<!--  --><div mat-dialog-title>
    {{'LOCATION.location'|translate}}

    <button (click)="newLocation()" *ngIf="!manual_save" class="btn btn-sm btn-default mx-2"> <i
            class="fa  fa-plus-circle mx-1"></i>
        {{'BTN.new' |translate}} </button>

    <span class="float-right pointer" (click)="close()">
        <i class="fa fa-times close-btn "></i>
    </span>
</div>

<ng-container *ngIf="data ">
    <mat-dialog-content>
        <div class="row">
            <div class="col-md-7">
                <div id="drop-zone">
                    <input #search_input class="search-box" style="z-index: 1001;display: inline-block;" type="text"
                        autocomplete="off" placeholder="{{'Search'}}" (input)="setTimer()" ngInit
                        [func]="getPlaceAutocompleteRefPresent" [formControl]=" map_search" #addresstextPresent>

                </div>
                <google-map gle-map class="map-canvas" width="100%" height="95%" [zoom]="zoom" [center]="center"
                    [options]="options" (mapClick)="click($event)">

                    <map-marker #markerElem *ngFor="let marker of markers" [position]="marker.position"
                        [label]="marker.label" [title]="marker.title" [options]="marker.options">
                    </map-marker>

                    <map-info-window>{{ infoContent }}</map-info-window>
                </google-map>
            </div>
            <div class="col-md-5">
                <form [formGroup]="branch_form">
                    <div class="row">
                        <div class="col-md-12 form-container-special" *ngIf="!manual_save">
                            <mat-form-field floatLabel="always">
                                <mat-label>{{'LOCATION.title'|translate}}</mat-label>
                                <input class="w-93" matInput placeholder="{{'LOCATION.enter_location_title'|translate}}"
                                    required formControlName="title">
                            </mat-form-field>
                        </div>
                        <div class="col-md-12 form-container-special ">
                            <mat-form-field floatLabel="always">
                                <mat-label>{{'LOCATION.addressLine1'|translate}}</mat-label>
                                <textarea class="w-93" matInput required
                                    placeholder="{{'LOCATION.enter_addressLine1'|translate}}"
                                    formControlName="addressLine1" [title]="branch_form.value.addressLine1"
                                    type="search" (input)="setTimer()" style="width: 100%;"
                                    #addresstextPresent></textarea>
                            </mat-form-field>
                        </div>
                        <div class="col-md-12">
                            <mat-form-field floatLabel='always'>
                                <mat-label>
                                </mat-label>
                                <input matInput [placeholder]="'LOCATION.enter_addressLine2' |translate"
                                    formControlName='addressLine2'>
                            </mat-form-field>
                        </div>
                        <div class="col-md-6 form-container-special">
                            <tm-select [form_group]="branch_form" [form_control]="'cityId'" [auto_addition]="1"
                                [mandatory]="1" [auto_data]="branch_form.value.cityName"
                                [auto_form_control]="'cityName'" [label]="'LOCATION.cityId'|translate"
                                [data]="branch_form.value.cityId" [options]="masters.cityList"></tm-select>
                            <!-- <mat-form-field floatLabel="always">
                                <mat-label>{{'LOCATION.city'|translate}}</mat-label>
                                <input class="w-93" matInput placeholder="{{'LOCATION.enter_city'|translate}}"
                                    formControlName="city">
                            </mat-form-field> -->
                        </div>
                        <div class="col-md-6 form-container-special">
                            <tm-select [form_group]="branch_form" [mandatory]="1" [form_control]="'stateId'"
                                [auto_addition]="1" [auto_data]="branch_form.value.stateName"
                                [auto_form_control]="'stateName'" [label]="'LOCATION.stateId'|translate"
                                [data]="branch_form.value.stateId" [options]="masters.stateList"></tm-select>
                            <!-- <mat-form-field floatLabel="always">
                                <mat-label>{{'LOCATION.state'|translate}}</mat-label>
                                <input class="w-93" matInput placeholder="{{'LOCATION.enter_state'|translate}}"
                                    formControlName="state">
                            </mat-form-field> -->
                        </div>

                        <div class="col-md-6 form-container-special">
                            <tm-select [form_group]="branch_form" [form_control]="'countryId'" [auto_addition]="1"
                                [auto_data]="branch_form.value.countryName" [auto_form_control]="'countryName'"
                                [label]="'LOCATION.countryId'|translate" [data]="branch_form.value.countryId"
                                [options]="masters.countryList"></tm-select>
                            <!-- <mat-form-field floatLabel="always">
                                <mat-label>{{'LOCATION.country'|translate}}</mat-label>
                                <input class="w-93" matInput placeholder="{{'LOCATION.enter_country'|translate}}"
                                    formControlName="country">
                            </mat-form-field> -->
                        </div>


                        <div class="col-md-6 form-container-special">
                            <mat-form-field floatLabel="always">
                                <mat-label>{{'LOCATION.postal_code'|translate}}</mat-label>
                                <input class="w-93" matInput placeholder="{{'LOCATION.enter_postal_code'|translate}}"
                                    formControlName="postalCode">
                            </mat-form-field>
                        </div>
                        <div class="col-md-6" *ngIf="manual_save">
                            <tm-files-v2 [form_group]="branch_form" [form_control]="'attachments'"
                                [result]="branch_form.value.attachments" [label]="'LOCATION.attachments'|translate">
                            </tm-files-v2>
                        </div>
                        <div class=" col-md-6 ">
                            <tm-toggle [form_group]=" branch_form" [form_control]="'status'"
                                [data]="branch_form.value.status" [label]="'LOCATION.status'|translate">
                            </tm-toggle>
                        </div>
                    </div>
                </form>
            </div>
        </div>


    </mat-dialog-content>
</ng-container>



<mat-dialog-actions>
    <span style="font-size: 13px !important;" id="tm-popup-notification-window"> </span>

    <button style="min-width: 120px;" class="ml-auto btn-sm blob-btn-cancel btn mx-1 mx-1 tallite-action"
        (click)="close()">
        {{ 'BTN.cancel' | translate}}
        <span class="blob-btn-cancel__inner">
            <span class="blob-btn-cancel__blobs">
                <span class="blob-btn-cancel__blob"></span>
                <span class="blob-btn-cancel__blob"></span>
                <span class="blob-btn-cancel__blob"></span>
                <span class="blob-btn-cancel__blob"></span>
            </span>
        </span>
    </button>
    <button style="min-width: 120px;" class="blob-btn btn btn-sm  mx-1 float-right tallite-action" type="submit"
        (click)="submitLocation()">
        {{ 'BTN.submit' | translate }}
        <span class="blob-btn__inner">
            <span class="blob-btn__blobs">
                <span class="blob-btn__blob"></span>
                <span class="blob-btn__blob"></span>
                <span class="blob-btn__blob"></span>
                <span class="blob-btn__blob"></span>
            </span>
        </span>
    </button>
</mat-dialog-actions>